'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _bufferTools = require('@/libs/bufferTools');

var bufferTools = _interopRequireWildcard(_bufferTools);

var _BufferSettings = require('./BufferSettings');

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        BufferSettings: _BufferSettings2.default,
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: ['network', 'sidebarState'],
    data: function data() {
        return {
            collapsed: false,
            channel_filter: '',
            channel_filter_display: false,
            channel_add_display: false,
            channel_add_input_has_focus: false,
            channel_add_input: ''
        };
    },
    computed: {
        isActiveNetwork: function isActiveNetwork() {
            return _state2.default.getActiveNetwork() === this.network;
        },
        totalNetworkCount: function totalNetworkCount() {
            return _state2.default.networks.length;
        },
        filteredBuffers: function filteredBuffers() {
            var filter = this.channel_filter;
            var filtered = [];

            if (!filter) {
                filtered = this.network.buffers;
            } else {
                filtered = _lodash2.default.filter(this.network.buffers, function (buffer) {
                    var name = buffer.name.toLowerCase();
                    return name.indexOf(filter) > -1;
                });
            }

            return bufferTools.orderBuffers(filtered);
        }
    },
    methods: {
        onNewChannelInputFocus: function onNewChannelInputFocus() {
            if (!this.channel_add_input) {
                this.channel_add_input = '#';
            }

            this.channel_add_input_has_focus = true;
        },
        onNewChannelInputBlur: function onNewChannelInputBlur() {
            if (this.channel_add_input === '#') {
                this.channel_add_input = '';
            }

            if (!this.channel_add_input) {
                this.channel_add_display = false;
            }

            this.channel_add_input_has_focus = false;
        },
        submitNewChannelForm: function submitNewChannelForm() {
            var newChannelVal = this.channel_add_input;
            this.channel_add_input = '#';

            var network = this.network;
            var bufferObjs = Misc.extractBuffers(newChannelVal);

            var hasSwitchedActiveBuffer = false;
            bufferObjs.forEach(function (bufferObj) {
                var chanName = bufferObj.name;
                var ignoreNames = ['#0', '0', '&0'];
                if (ignoreNames.indexOf(chanName) > -1 || chanName.replace(/[#&]/g, '') === '') {
                    return;
                }

                var newBuffer = _state2.default.addBuffer(network.id, chanName);
                if (newBuffer && !hasSwitchedActiveBuffer) {
                    _state2.default.setActiveBuffer(network.id, newBuffer.name);
                    hasSwitchedActiveBuffer = true;
                }

                if (bufferObj.key) {
                    newBuffer.key = bufferObj.key;
                }

                if (network.isChannelName(chanName)) {
                    network.ircClient.join(chanName, bufferObj.key);
                }
            });
        },
        onChannelFilterInputBlur: function onChannelFilterInputBlur() {
            var _this = this;

            if (!this.channel_filter) {
                setTimeout(function () {
                    _this.closeFilterChannel();
                }, 200);
            }
        },
        closeBuffer: function closeBuffer(buffer) {
            _state2.default.removeBuffer(buffer);
        },
        awayNotifySupported: function awayNotifySupported() {
            return this.network.ircClient.network.cap.isEnabled('away-notify');
        },

        showMessageCounts: function showMessageCounts(buffer) {
            return !buffer.setting('hide_message_counts');
        },
        setActiveBuffer: function switchContainer(buffer) {
            this.sidebarState.close();

            _state2.default.$emit('active.component', null);
            _state2.default.setActiveBuffer(buffer.networkid, buffer.name);
            if (this.$state.ui.is_narrow) {
                _state2.default.$emit('statebrowser.hide');
            }
        },
        isActiveBuffer: function isActiveBuffer(buffer) {
            return buffer.networkid === _state2.default.ui.active_network && buffer.name === _state2.default.ui.active_buffer;
        },
        showNetworkSettings: function showNetworkSettings(network) {
            network.showServerBuffer('settings');
        },
        showNetworkChannels: function showNetworkChannels(network) {
            network.showServerBuffer('channels');
        },
        toggleAddChannel: function toggleAddChannel() {
            this.channel_add_display = !this.channel_add_display;
            this.channel_filter_display = false;
        },
        toggleFilterChannel: function toggleFilterChannel() {
            this.channel_filter_display = !this.channel_filter_display;
            this.channel_add_display = false;
        },
        closeFilterChannel: function closeFilterChannel() {
            this.channel_filter = '';
            this.channel_filter_display = false;
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowserNetwork"]
window._kiwi_exports.components.StateBrowserNetwork = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StateBrowserNetwork.vue
// module id = Qyqn
// module chunks = 1